import UserGroupUsersTableHelper from "./usergroup-users-table-helper";
import UserGroupsTableHelper     from "./usergroups-table-helper";

const UserGroupHelpers = {
    TableMain  : UserGroupsTableHelper,
    TableUsers : UserGroupUsersTableHelper,
}

export default UserGroupHelpers;